module.exports = __webpack_public_path__ + "static/feature_colorado_mts_lake-be5b702d64ed1c8d4923eba35b8aeaf6.jpg";